import { render } from "./Invoicing.vue?vue&type=template&id=9854d764"
import script from "./Invoicing.vue?vue&type=script&lang=js"
export * from "./Invoicing.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__